export const aciExclamation = {
    iconName: 'exclamation',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 4 21' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M0 19a2 2 0 114 0 2 2 0 01-4 0zM2 0c.552 0 1 .56 1 1.25v12.5C3 14.44 2.552 15 2 15s-1-.56-1-1.25V1.25C1 .56 1.448 0 2 0z',
                fill: 'currentColor',
            },
        },
    },
};
